import React, { useState } from "react";
import LogoImage from "../images/logo.svg";
import { Link, NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { searchChangeFilter } from "../../features/filters/filtersReducer";

const Navigation = () => {
  const { search } = useSelector((state) => state.filters);
  const [searchText, setSearchText] = useState(search);
  const dispatch = useDispatch();

  const onSubmitHandler = (e) => {
    e.preventDefault();
  };

  // onInputChangeHandler function will be called when the searchText changes ...
  const onInputChangeHandler = (e) => {
    setSearchText(e.target.value);
    dispatch(searchChangeFilter(e.target.value));
  };

  return (
    <nav className="py-4 2xl:px-6">
      <div className="container flex items-center justify-between">
        <Link to="/">
          <img src={LogoImage} width="150px" className="object-contain" />
        </Link>

        <ul className="hidden md:flex items-center space-x-6">
          <NavLink
            to={`/`}
            className={({ isActive }) =>
              isActive ? "font-semibold cursor-pointer" : "cursor-pointer"
            }
            id="lws-bookStore"
          >
            <li>Book Store</li>
          </NavLink>
          <NavLink
            to={`/add`}
            className={({ isActive }) =>
              isActive ? "font-semibold cursor-pointer" : "cursor-pointer"
            }
            id="lws-addBook"
          >
            <li>Add Book</li>
          </NavLink>
        </ul>

        <form className="flex items-center" onSubmit={onSubmitHandler}>
          <div className="group relative rounded-md bg-white">
            <svg
              width="20"
              height="20"
              fill="currentColor"
              className="absolute left-3 top-1/2 -mt-2.5 text-slate-400 pointer-events-none group-focus-within:text-primary"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
              ></path>
            </svg>
            <input
              type="text"
              placeholder="Filter books..."
              className="search"
              id="lws-search"
              value={searchText}
              onChange={onInputChangeHandler}
            />
          </div>
        </form>
      </div>
    </nav>
  );
};

export default Navigation;
